import React from 'react';
const testimonials = [{
  text: 'Passavo ore ogni domenica a programmare le lezioni. Ora apro il sistema, scelgo il workout e sono pronto. Mi ha fatto risparmiare tantissimo tempo.',
  author: 'Marco R.',
  role: 'Functional Coach',
  location: 'Milano'
}, {
  text: 'Il modulo Session Builder da solo vale il prezzo. Finalmente ho una struttura chiara per creare allenamenti professionali.',
  author: 'Luca B.',
  role: 'Personal Trainer',
  location: 'Roma'
}, {
  text: 'Gestisco gruppi con livelli molto diversi e questo sistema mi ha dato un metodo semplice per organizzare tutto.',
  author: 'Giulia T.',
  role: 'Coach di Functional Training',
  location: 'Torino'
}, {
  text: 'I workout già pronti e i programmi progressivi mi hanno aiutato a migliorare la qualità delle mie lezioni senza aumentare il tempo di preparazione.',
  author: 'Andrea M.',
  role: 'Fitness Coach',
  location: 'Bologna'
}, {
  text: 'Da quando uso questo sistema, i miei clienti notano la differenza. Le lezioni sono più fluide e io mi sento molto più sicura mentre insegno.',
  author: 'Valentina S.',
  role: 'Istruttrice Bootcamp',
  location: 'Firenze'
}];
export function Testimonials() {
  return <section className="py-10 px-5 bg-white" data-id="element-147">
      <h2 className="text-2xl font-heading font-bold text-center text-petrol mb-8" data-id="element-148">
        COSA DICONO GLI ALTRI PROFESSIONISTI
      </h2>

      <div className="flex flex-col gap-4" data-id="element-149">
        {testimonials.map((t, i) => <div key={i} className="bg-cream p-5 border border-cream" data-id="element-150">
            <div className="text-gold text-sm mb-2" data-id="element-151">⭐⭐⭐⭐⭐</div>
            <p className="text-graphite text-sm italic mb-3" data-id="element-152">"{t.text}"</p>
            <p className="font-bold text-petrol text-sm font-subheading" data-id="element-153">
              — {t.author}
            </p>
            <p className="text-xs text-graphite" data-id="element-154">
              {t.role} — {t.location}
            </p>
          </div>)}
      </div>
    </section>;
}